module.exports = __webpack_public_path__ + "img/logoFull2.e6db0ec1.svg";